import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { AlertService } from "@app/modules/alert";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";

import { BaseService } from "./base.service";
import { IStatisticsDateRange, IStatisticsGeneral, IMonthlySummary, IStatisticsStatus, IClosedSummary, IStatisticsRequestType } from "@app/models/statistics";

@Injectable({
    providedIn: "root",
})
export class StatisticsService extends BaseService  {
    //url = protectedResources.apiUrl.endpoint + "statistics";
    url = this.getBaseURL() + "statistics";

    errorOptions = {
        autoClose: false,
        keepAfterRouteChange: false,
    };
    constructor(private http: HttpClient, private alertService: AlertService) {
        super();
    }

    getGeneralStatistics(opts: IStatisticsDateRange) {
        const url = this.url + "/byPeriod";
       
        
        let params = new HttpParams();
        
        if (opts.fromDate) {
            params=params.set("fromDate",  opts.fromDate);            
        } 
        if (opts.toDate) {
            params=params.set("toDate",opts.toDate);           
        } 
  
        return this.http.get<IStatisticsGeneral>(url,  {headers: this.setCustomRequestheaders(), params: params}).pipe(
            catchError(
                (error: unknown, caught: Observable<any>): Observable<any> => {

                    this.alertService.error(
                        "Error loading data from database : " +
                            this.checkStatusCode(error),
                        this.errorOptions
                    );
                    throw error;
                }
            )
        );
    }
    
    getProjectStatistics(opts: IStatisticsDateRange) {
        const url = this.url + "/ProjectsByPeriod";
       
        
        let params = new HttpParams();
        
        if (opts.fromDate) {
            params=params.set("fromDate",  opts.fromDate);            
        } 
        if (opts.toDate) {
            params=params.set("toDate",opts.toDate);           
        } 
  
        return this.http.get<IStatisticsGeneral>(url,  {headers: this.setCustomRequestheaders(), params: params}).pipe(
            catchError(
                (error: unknown, caught: Observable<any>): Observable<any> => {

                    this.alertService.error(
                        "Error loading data from database : " +
                            this.checkStatusCode(error),
                        this.errorOptions
                    );
                    throw error;
                }
            )
        );
    }

    getMonthlySummaryStatistics() {
        const url = this.url + "/monthlySummary";
        return this.http.get<IMonthlySummary[]>(url, {headers: this.setCustomRequestheaders()}).pipe(
            catchError(
                (error: unknown, caught: Observable<any>): Observable<any> => {
                    this.alertService.error(
                        "Error loading data from database : " +
                            this.checkStatusCode(error),
                        this.errorOptions
                    );
                    throw error;
                }
            )
        );
    }
    getClosedSummaryStatistics() {
        const url = this.url + "/closedSummary";
        return this.http.get<IClosedSummary[]>(url, {headers: this.setCustomRequestheaders()}).pipe(
            catchError(
                (error: unknown, caught: Observable<any>): Observable<any> => {
                    this.alertService.error(
                        "Error loading data from database : " +
                            this.checkStatusCode(error),
                        this.errorOptions
                    );
                    throw error;
                }
            )
        );
    }
    getStatusStatistics() {
        const url = this.url + "/byStatus";
        return this.http.get<IStatisticsStatus[]>(url, {headers: this.setCustomRequestheaders()}).pipe(
            catchError(
                (error: unknown, caught: Observable<any>): Observable<any> => {

                    this.alertService.error(
                        "Error loading data from database : " +
                            this.checkStatusCode(error),
                        this.errorOptions
                    );
                    throw error;
                }
            )
        );
    }
    getRequestTypeStatistics() {
        const url = this.url + "/byRequestType";
        return this.http.get<IStatisticsRequestType[]>(url, {headers: this.setCustomRequestheaders()}).pipe(
            catchError(
                (error: unknown, caught: Observable<any>): Observable<any> => {

                    this.alertService.error(
                        "Error loading data from database : " +
                            this.checkStatusCode(error),
                        this.errorOptions
                    );
                    throw error;
                }
            )
        );
    }   
}
